export default "__VITE_ASSET__Blft_Sng__"